import { createStyles } from 'antd-style'

export const useStyle = createStyles({
  organizationImage: {
    objectFit: 'cover'
  }
})
